module.exports = __webpack_public_path__ + "img/padlock-icon.347f2451.svg";